import { Directive } from '@angular/core';

@Directive({
  selector: '[appMessageCardIcon]',
  standalone: true,
})
export class MessageCardIconDirective {}
